import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/app/operator/routing/users")({
  validateSearch: z.object({
    section: z.enum(["default", "users"]).optional().catch(undefined),
    tenant: z.string().optional(),
    user: z.string().optional(),
  }),
  beforeLoad: ({ search, location }) => {
    throw redirect({
      to: "/app/operator/routing",
      search: { ...search, view: "users" },
      hash: location.hash,
      replace: true,
    });
  },
});
